module.exports = __webpack_public_path__ + "img/light_on.03fd5d2e.png";